import React from "react";
import { ListItems } from "../../../../../../../shared/ListItems/ListItems";
import {
  IGeometryOption,
  IOption,
  IVariant,
  optionObjectOptionT,
} from "../../../../../../../redux/reducers/ui/uiTypes";
import { DropDown } from "../../../../../../../shared/DropDown/DropDown";
import { ObjectOptionGroupItem } from "./ObjectOptionGroupItem";

interface OptionDataI {
  variant: IVariant;
  option: IOption | IGeometryOption;
}

interface IProps {
  productId: string;
  type: optionObjectOptionT;
  proxyId: number;
  options: (IOption | IGeometryOption)[];
  title: string;
}
export const ObjectOptionGroup: React.FC<IProps> = props => {
  const { productId, type, proxyId, options, title } = props;
  // Build list preserving both option and variant so we know optionId
  const optionsData: OptionDataI[] = options.flatMap(option =>
    option.variants
      .filter(variant => variant.enabled)
      .map(variant => ({ variant, option }))
  );

  return (
    <DropDown title={title}>
      <ListItems
        list={[
          ...optionsData.map(optionD => (
            <ObjectOptionGroupItem
              productId={productId}
              type={type}
              proxyId={proxyId}
              optionData={optionD}
            />
          )),
        ]}
        type={optionsData[0]?.variant?.image ? "image" : "text"}
      />
    </DropDown>
  );
};
